import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tm-express',
  templateUrl: './tm-express.component.html',
  styleUrls: ['./tm-express.component.scss']
})
export class TmExpressComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
